import { p as proxyCustomElement, H, c as createEvent, h, F as Fragment, a as Host } from './index.js';
import { g as getValidityObject, c as checkValidity, r as reportValidity, s as setCustomValidity, a as setInputRef, b as getError, w as watchError, d as watchWarning, e as getFormFieldAttributes, f as getHostAttributes } from './p-De5ZxJ78.js';
import { t as toValue, a as toLabel } from './p-CPuegN2k.js';
import { i as isOtherOption } from './p-CD8wTaMP.js';
import { H as HiddenHTMLSelect } from './p-C9VOiWMi.js';
import { d as defineCustomElement$7 } from './p-BbTg3Car.js';
import { d as defineCustomElement$6 } from './p-BGf1Yrc6.js';
import { d as defineCustomElement$5 } from './p-06zXtNjY.js';
import { d as defineCustomElement$4 } from './p-C78HRAnj.js';
import { d as defineCustomElement$3 } from './p-C4juph28.js';
import { d as defineCustomElement$2 } from './p-Cr5d_5Z4.js';
import { d as defineCustomElement$1 } from './p-CZA0kb6w.js';

const checkInputGroupCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;display:flex;flex:none;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;width:100%}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}.inner{display:flex;gap:.75rem}span.header{color:var(--jw-theme-form-label-color);font-family:Open Sans;font-size:.875rem;font-weight:600;letter-spacing:-.0004em;line-height:1.25rem;margin-bottom:-.75rem;margin-top:-.75rem;padding-bottom:.25rem;padding-top:1rem}span.header:first-child{margin-top:0;padding-top:0}span.header:last-child{margin-bottom:0;padding-bottom:0}:host([orientation=horizontal]) .inner{flex-direction:row}:host([orientation=horizontal]) wui-check-input{flex:1}:host([orientation=vertical]) .inner{flex-direction:column}:host([orientation=vertical]) wui-check-input{width:100%}";

const WuiCheckInputGroup = /*@__PURE__*/ proxyCustomElement(class WuiCheckInputGroup extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.validityChecked = createEvent(this, "validityChecked", 7);
        this.validityReported = createEvent(this, "validityReported", 7);
        this.required = false;
        this.validity = getValidityObject();
        this.validationMessage = '';
        this.customValidation = undefined;
        this.checkValidity = checkValidity(this);
        this.reportValidity = reportValidity(this);
        this.setCustomValidity = setCustomValidity(this);
        this.showValidity = false;
        this.setInputRef = setInputRef(this);
        this.dirty = false;
        this.getError = getError(this);
        //////// FORM FIELD END ////////
        /**
         * Options
         */
        this.options = [];
        /**
         * Inner WuiBox `orientation`
         */
        this.orientation = 'vertical';
        /**
         * If disabled
         */
        this.disabled = false;
        this.size = 'md';
        this.handleInput = (e, option) => {
            // Stop the inner input event from bubbling up
            e.stopPropagation();
            if (this.disabled) {
                return;
            }
            const val = toValue(option);
            if (typeof val === 'undefined') {
                return;
            }
            const newValue = [...(this.value ?? [])];
            if (newValue.includes(val)) {
                this.value = newValue.filter((v) => v !== val);
            }
            else {
                this.value = [...newValue, val];
            }
            this.dirty = true;
            this.checkValidity();
            this.elm.dispatchEvent(new window.Event('input', { bubbles: true }));
        };
    }
    _watchError(...args) {
        watchError(this, ...args);
    }
    _watchWarning(...args) {
        watchWarning(this, ...args);
    }
    renderInner() {
        return (h(Fragment, null, h(HiddenHTMLSelect, { ref: this.setInputRef, value: this.value, options: this.options, required: !!this.required, disabled: this.disabled, multiple: true, name: this.name }), h("div", { class: "inner" }, this.options?.map((option, idx) => {
            if (isOtherOption(option)) {
                return (h("span", { class: "header", key: idx }, option.label));
            }
            const label = toLabel(option);
            const value = toValue(option);
            const checked = (this.value || []).includes(value);
            const disabled = typeof option === 'object' ? option.disabled : undefined;
            const description = typeof option === 'object' && 'description' in option ? option.description : undefined;
            return (h("wui-check-input", { ...(typeof option === 'object' ? option : {}), key: idx, description: this.size === 'md' ? undefined : description, formField: this.size === 'md' && description ? { description } : undefined, checked: checked, disabled: this.disabled || disabled, onChange: (e) => {
                    // Prevent change event from bubbling up
                    e.stopPropagation();
                }, onInput: (e) => this.handleInput(e, option), name: this.name ? `${this.name}[]` : undefined, value: value, label: label }));
        }))));
    }
    render() {
        return (h(Host, { key: '2b74dc4252b847f5702cdb698616268e593f03d9', ...getHostAttributes(this) }, h("wui-form-field", { key: '9a60105aaaad3bc6c5b08118110ef3e413772230', ...getFormFieldAttributes(this) }, this.renderInner())));
    }
    get elm() { return this; }
    static get watchers() { return {
        "error": ["_watchError"],
        "warning": ["_watchWarning"]
    }; }
    static get style() { return checkInputGroupCss; }
}, [257, "wui-check-input-group", {
        "value": [1040],
        "required": [8],
        "error": [8],
        "warning": [8],
        "validate": [16],
        "validity": [1040],
        "validationMessage": [1025, "validation-message"],
        "checkValidity": [16, "check-validity"],
        "reportValidity": [16, "report-validity"],
        "setCustomValidity": [16, "set-custom-validity"],
        "formField": [16, "form-field"],
        "options": [16],
        "orientation": [513],
        "disabled": [516],
        "name": [1],
        "size": [513],
        "customValidation": [32],
        "showValidity": [32]
    }, undefined, {
        "error": ["_watchError"],
        "warning": ["_watchWarning"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-check-input-group", "wui-box", "wui-check-input", "wui-form-field", "wui-icon", "wui-status", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-check-input-group":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiCheckInputGroup);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-check-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-form-field":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-status":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiCheckInputGroup as W, defineCustomElement as d };
